"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddPaymentAccount = void 0;
const tslib_1 = require("tslib");
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const internal_1 = require("./internal");
/**
 * Add payment account to customer via CustomerServices.
 *
 * If saved payments are represented using SavedPaymentMethods and stored in
 * PaymentTransactionServices, {@link #useAddSavedPaymentMethod} should be used instead.
 *
 * @deprecated In favor of using {@link #useAddSavedPaymentMethod} and PaymentTransactionServices to manage saved payment methods.
 */
const useAddPaymentAccount = (props) => {
    const { authState, customerClient, previewOptions } = props;
    const getCustomerToken = (0, internal_1.useGetCustomerAccessToken)({ authState });
    const { customerId, isAuthenticated } = authState;
    const [error, setError] = (0, react_1.useState)();
    const [isFetching, setIsFetching] = (0, react_1.useState)(false);
    const [account, setAccount] = (0, react_1.useState)();
    const addPaymentAccount = (0, react_1.useCallback)((paymentAccount) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
        var _a;
        if (!isAuthenticated) {
            return;
        }
        try {
            setIsFetching(true);
            const accessToken = yield getCustomerToken();
            const response = yield customerClient.addCustomerPaymentAccount(customerId, paymentAccount, {
                accessToken,
                preview: previewOptions
            });
            setError(undefined);
            setAccount(response);
            return response;
        }
        catch (error) {
            if (axios_1.default.isCancel(error)) {
                // do nothing if cancelled
                return;
            }
            if (axios_1.default.isAxiosError(error)) {
                setError((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
            }
            return;
        }
        finally {
            setIsFetching(false);
        }
    }), [
        customerClient,
        customerId,
        getCustomerToken,
        isAuthenticated,
        previewOptions
    ]);
    return { account, addPaymentAccount, error, isFetching };
};
exports.useAddPaymentAccount = useAddPaymentAccount;
//# sourceMappingURL=use-add-payment-account.js.map